export const OrderIdentifiersJSONSchema = {
  type: 'object',
  properties: {
    paymentTransactionId: {
      type: 'string',
      description: 'OD',
    },
    sfOrderId: {
      type: 'string',
    },
    paymentTransactionSystem: {
      type: 'string',
    },
  },
}

export const OrderIdentifiersJSONUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/paymentTransactionId',
          component: 'ReadOnlyFieldWithJson',
          label: 'Payment Transaction ID',
        },
        {
          type: 'Control',
          scope: '#/properties/sfOrderId',
          component: 'ReadOnlyFieldWithJson',
          label: 'SF Order ID',
        },
        {
          type: 'Control',
          scope: '#/properties/paymentTransactionSystem',
          component: 'ReadOnlyFieldWithJson',
          label: 'Payment Transaction System ',
        },
      ],
    },
  ],
}
